import React, { Component } from "react";
import {LOGIN_TYPE_ADMIN, api_sources, GET_MASTER_SERVICE} from "./helper/Constants";
import Apihelpers from "./helper/ApiHelper";
import { NavLink } from "react-router-dom";
import { reactLocalStorage } from "reactjs-localstorage";
import UnAuthorised from "./UnAuthorised";
import $ from "jquery";
import Select2 from 'react-select2-wrapper';
//import { Alert } from 'rsuite';
import Header from "./include/Header";
const urlParams = new URLSearchParams(window.location.search);

export default  class UpdateApiSourceOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listData:[],
      gotDataApiType:'RCPrime',
      filters:{
        startpage:0,
        limit:10,
        apiType:urlParams.get("apiType") || 'RCPrime',
        search:'all',
        totalCount:0
      },
      updateSourcePopUp: false
    };
  }

  componentDidMount() {
    //console.log(reactLocalStorage.get("authToken"));
    if (reactLocalStorage.get("login_type") === LOGIN_TYPE_ADMIN) {
      this.loadListData();
    }
    $("body").on(".customPopup select2:select", function (evt) {
      var element = evt.params.data.element;
      //console.log('element',element);
      var $element = $(element);
      let id = evt.target.id;
      console.log('select2 id',id);
      $element.detach();
      $('#'+id).append($element);
      $('#'+id).trigger("change");
    })
  }

  loadListData() {
    let parmes = '?limit='+this.state.filters.limit+'&skip='+(this.state.filters.limit * this.state.filters.startpage)+'&loginStatus=login-active&apiType='+this.state.filters.apiType+'&search='+this.state.filters.search;
    $(".loader").show();
    Apihelpers.getdataresponse('bbuser/get_source_order_list'+parmes).then(res => {
      if (res.data.status === true) {
        this.setState({
          listData: res.data.data.record,
          filters:{...this.state.filters, totalCount:res.data.data.totalCount},
          gotDataApiType: this.state.filters.apiType
        });
        //this.loadAllServices();
        $(".itemCheck").prop('checked', false);
        $("#bulkCheck").prop('checked', false);
        $(".loader").hide();
      } else {
        this.setState({
          listData: []
        });
      }
    });
  }

  loadAllServices() {
    Apihelpers.getdataresponse(GET_MASTER_SERVICE).then(res => {
      if (res.data.status === true) {
        this.setState({
          masterServices: res.data.data,
          //isloaded: true
        });
      } else {
        this.setState({
          masterServices: []
        });
      }
    });
  }

  loadPage = (e) => {
    //console.log('e',e.target.getAttribute("data-i"));
    let start = Number(e.target.getAttribute("data-i"));
    this.setState({
      filters: {...this.state.filters, startpage: start}
    });
    setTimeout(()=>{
      this.loadListData();
    },100);
  }
  changeLimit = (e) => {
    let limit = Number(e.target.value);
    this.setState({
      filters: {
        startpage:0,
        limit:limit,
        paidType:'all',
        apiType:'RCPrime',
        search:'all',
        totalCount:0
      }
    });
    setTimeout(()=>{
      this.loadListData();
    },100);
  }

  removeFilter = () => {
    this.setState({
      filters: {
        startpage:0,
        limit:10,
        apiType:'RCPrime',
        search:'all',
        totalCount:0
      }
    });
    urlParams.set('apiType', 'RCPrime');
    window.history.replaceState(null, null, '?'+urlParams.toString());
    setTimeout(()=>{
      this.loadListData();
    },100);
  }
  setClientId = () => {
    var businessname = $("#filterbusinessname").val();
    console.log('businessname',businessname);
    if (businessname !== null) {
      this.setState({filters: {...this.state.filters, search:businessname} });
    }
  }

  bulkCheck = (e) => {
    console.log('e.target', e.target.checked);
    $(".itemCheck").prop('checked', e.target.checked);
  }

  submitBulkSourceOrder = () => {
    let source = $("#sourceUpdate").val();
    /*if(!source.length) {
      alert('Please select source');
      return;
    }
    console.log('source',source);
    */
    let selectedClients = [];
    $('.itemCheck:checked').each(function(){
      selectedClients.push($(this).val())
    })
    if(!selectedClients.length) {
      alert('Please select clients in list by checkbox')
      return;
    }
    console.log('selectedClients',selectedClients);
    let data = {
      objIdes: selectedClients,
      source: source,
      apiType: this.state.gotDataApiType
    }
    $(".loader").show();
    Apihelpers.postdataresponse('bbuser/update_source_order',data).then(res => {
      //console.log('res.data',res.data);
      if (res.data.status === true) {
        //$(".loader").hide();
        this.loadListData();
        this.setState({updateSourcePopUp:false});
        $(".itemCheck").prop('checked', false);
        $("#bulkCheck").prop('checked', false);
      } else {
        alert('Somthing Went Wrong');
      }
    });

  }

  render() {
    if (reactLocalStorage.get("login_type") === LOGIN_TYPE_ADMIN) {
      const renderPaging = () => {
        let pages = (this.state.filters.totalCount / this.state.filters.limit);
        //console.log('pages',pages);
        let pagingHmtl = [];
        for (var i = 0; pages > i; i++ ) {
          pagingHmtl.push(<span key={i} data-i={i} className={(this.state.filters.startpage == i) ? 'btn active' : 'btn'} onClick={(e)=>{this.loadPage(e)}}>{i+1}</span>);
        }
        return pagingHmtl;
      }
      return (
        <React.Fragment>
          <div className="wrapper">
            <Header />
            <div className="container">
              <div className="clientListPage sourceOrderPage">
                <div className="titleBg">
                  <div className="row">
                    <div className="col">
                      <h3 className="title">Clients <span className="count">(Showing {this.state.listData.length} out of {this.state.filters.totalCount} )</span></h3>
                    </div>
                    <div className="col-auto">
                      <NavLink className="createClientLink" to={"/admin/client-list"} > Client List</NavLink>
                    </div>
                  </div>
                </div>
                {
                  //JSON.stringify(this.state.filters,null,2)
                }
                {
                  //JSON.stringify(this.state.listData,null,2)
                }
                <div className="row">
                  <div className="col-12">
                    <div className="filterRow">
                      <div className="form-group">
                        <select className="form-control" onChange={(e)=>{
                          this.setState({filters:{...this.state.filters, apiType:e.target.value, startpage: 0}})
                          urlParams.set('apiType', e.target.value);
                          window.history.replaceState(null, null, '?'+urlParams.toString());
                          setTimeout(()=>{
                            this.loadListData();
                          },100) 
                        }} value={this.state.filters.apiType}>
                          <option value="RCPrime">RC Prime</option>
                          <option value="RCExcel">RC Excel</option>
                          <option value="ChallanExcel">Challan Excel</option>
                          <option value="Challan">Challan API</option>
                          <option value="comboPrime">Combo Prime</option>
                          <option value="comboChallan">Combo Challan</option>
                          <option value="comboMobilePrimeExcel">Combo Mobile RC Excel</option>
                        </select>
                      </div>
                      {/* <div className="form-group">
                        <select className="form-control" onChange={(e)=>{
                          this.setState({filters:{...this.state.filters, loginStatus:e.target.value, startpage:0}});
                          urlParams.set('loginStatus', e.target.value);
                          window.history.replaceState(null, null, '?'+urlParams.toString());
                        }} value={this.state.filters.loginStatus}>
                          <option value="all">All</option>
                          <option value="login-active"> Login Active</option>
                          <option value="login-inactive">Login Inactive</option>
                        </select>
                      </div> */}
                      {/* <div className="form-group">
                        <Select2
                          data={this.state.clientsArray}
                          options={{
                            placeholder: 'Search Business Name',
                          }}
                          id="filterbusinessname"
                          className="form-control"
                          value={this.state.filters.search}
                          onChange={()=>{this.setClientId()}}
                        />
                      </div> */}
                      {/* <div className="form-group btnRow">
                        <button className="blueBtn" onClick={()=>{this.loadListData()}} type="button"><i className="fa fa-filter"></i></button>
                      </div>
                      <div className="form-group btnRow">
                        <button className="backBtn" onClick={()=>{this.removeFilter()}} type="button"><i className="fa fa-undo"></i></button>
                      </div> */}
                      <div className="form-group btnRow" style={{float:'right'}}>
                        <button className="blueBtn" type="button" onClick={()=>{
                            let selectedClients = [];
                            $('.itemCheck:checked').each(function(){
                              selectedClients.push($(this).val())
                            })
                            if(!selectedClients.length) {
                              alert('Please select clients in list by checkbox')
                              return;
                            }
                            this.setState({updateSourcePopUp:true});
                          }}>Update source</button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tableBorder">
                  <table className="table">
                    <thead>
                      <tr>
                        <th style={{width:'40px'}}>
                          <input id="bulkCheck" type="checkbox" onChange={(e) => this.bulkCheck(e)} />
                        </th>
                        <th>Client Name</th>
                        <th>{this.state.gotDataApiType} Source Order</th>
                        <th>Login Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.listData.length > 0 ?
                        this.state.listData.map((item, index) => {
                          let active_plan = JSON.parse(item.active_plan).service;
                          //console.log('active_plan',active_plan);
                          let plans = (<div className="apiPlans">
                            <span className="txt">Assign Plans</span>
                              <div className="toolTip">
                                <i className="infoIcon"></i>
                                <div className="toolTipText">
                                  {
                                    active_plan.map((plan)=>{
                                      return(
                                        <div key={plan.plantype} className="row">
                                          <div className="col">{plan.plantype}</div>
                                          <div className="col-auto">
                                            {
                                              (plan.isActive === 0) ?
                                              (<i className="fa fa-eye-slash"></i>)
                                              : (plan.isActive === 1) ?
                                              (<i className="fa fa-eye"></i>)
                                              :
                                              ""
                                            }
                                          </div>
                                        </div>
                                      )
                                    })
                                  }
                                </div>
                              </div>
                            </div>);
                          
                          let sourceOrder;
                          if(this.state.gotDataApiType === 'comboPrime') {
                            let comboSourceArray = item.rcPrimeChallan_prime_source_order || [];
                            sourceOrder = (<div className="soruce-update">
                              {
                                comboSourceArray.map((it)=>{
                                  return(<span key={it} className="sourceitem">{it}</span>)
                                })
                              }
                            </div>)
                          } else if(this.state.gotDataApiType === 'RCPrime') {
                            let rcPrimeSourceArray = item.rc_prime_api_source_order || [];
                            sourceOrder = (<div className="soruce-update">
                              {
                                rcPrimeSourceArray.map((it)=>{
                                  return(<span key={it} className="sourceitem">{it}</span>)
                                })
                              }
                            </div>)
                          } else if(this.state.gotDataApiType === 'RCExcel') {
                            let rcExcelSourceArray = item.rc_excel_api_source_order || [];
                            sourceOrder = (<div className="soruce-update">
                              {
                                rcExcelSourceArray.map((it)=>{
                                  return(<span key={it} className="sourceitem">{it}</span>)
                                })
                              }
                            </div>)
                          } else if(this.state.gotDataApiType === 'comboMobilePrimeExcel') {
                            let rcExcelSourceArray = item.mobile_rc_excel_api_source_order_for_Api || [];
                            sourceOrder = (<div className="soruce-update">
                              {
                                rcExcelSourceArray.map((it)=>{
                                  return(<span key={it} className="sourceitem">{it}</span>)
                                })
                              }
                            </div>)
                          }else if(this.state.gotDataApiType === 'ChallanExcel') {
                            let challanExcelSourceArray = item.challan_excel_api_source_order || [];
                            sourceOrder = (<div className="soruce-update">
                              {
                                challanExcelSourceArray.map((it)=>{
                                  return(<span key={it} className="sourceitem">{it}</span>)
                                })
                              }
                            </div>)
                          } else if(this.state.gotDataApiType === 'Challan') {
                            let challanSourceArray = item.challan_api_source_order || [];
                            sourceOrder = (<div className="soruce-update">
                              {
                                challanSourceArray.map((it)=>{
                                  return(<span key={it} className="sourceitem">{it}</span>)
                                })
                              }
                            </div>)
                          } else if(this.state.gotDataApiType === 'comboChallan') {
                            let comboChallanArray = item.rcPrimeChallan_challan_source_order || [];
                            sourceOrder = (<div className="soruce-update">
                              {
                                comboChallanArray.map((it)=>{
                                  return(<span key={it} className="sourceitem">{it}</span>)
                                })
                              }
                            </div>)
                          }
                          
                          return (
                            <tr key={index}>
                              <td><input className="itemCheck" type="checkbox" value={item._id} /></td>
                              <td>
                                <NavLink title="Edit Pack" to={`${"/admin/client-edit-view/" + item._id}`}>
                                {item.business_name} 
                                </NavLink>
                                <br />{plans}
                              </td>
                              <td>{sourceOrder}</td>
                              <td>
                                {
                                  (item.is_active === true) ?
                                  (<span className="col-status">Active</span>)
                                  : (item.is_active === false) ?
                                  (<span className="col-status-in">InActive</span>)
                                  :
                                  ""
                                }
                              </td>
                            </tr>
                          )
                        })
                        :
                        <tr>
                          <td colSpan="4" align="center">
                            <img src="/assets/images/data-not-found-img.png" /><br /><br />
                            <b>No Data Found</b>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
                <div className="row">
                  <div className="col">
                    <div className="pageing">
                      {/* <span className="btn active">1</span>
                      <span className="btn">2</span>
                      <span className="btn">3</span>
                      <span className="btn">4</span> */}
                      {renderPaging()}
                    </div>
                  </div>
                  <div className="col-auto">
                    <select className="form-control" onChange={this.changeLimit} defaultValue={10}>
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="20">20</option>
                      <option value="30">30</option>
                      <option value="40">40</option>
                      <option value="50">50</option>
                    </select>
                  </div>
                </div>
              </div>

            </div>
            <div className="loader">
              <div className="bg"></div>
              <img className="loadingImg" src="/assets/images/loading.gif" alt="" />
            </div>
          </div>
          {
            (this.state.updateSourcePopUp) ?
            <div className="customPopup" style={{display:'block'}}>
              <div className="bgLayer" />
              <div className="popUpBox" style={{maxWidth:"500px"}}>
                <span className="closeIcon" onClick={()=>{this.setState({updateSourcePopUp:false})}}></span>
                <div className="popScroll" style={{padding:"20px 20px 30px 20px"}}>
                  <div className="popUpHed">
                    <h3>Source Order Update in Bulk</h3>
                  </div>
                  <div className="form">
                    <div className="form-group">
                      <label className="control-title">{this.state.gotDataApiType} Source Order</label>
                      <Select2
                        data={
                          (this.state.gotDataApiType === 'RCPrime') ?
                            api_sources.RCPrime
                          : (this.state.gotDataApiType === 'comboPrime') ?
                            api_sources.RCPrime
                          : (this.state.gotDataApiType === 'RCExcel') ?
                            api_sources.RCExcel
                          : (this.state.gotDataApiType === 'comboMobilePrimeExcel') ?
                            api_sources.MobileRCExcel
                          : (this.state.gotDataApiType === 'ChallanExcel') ?
                            api_sources.ChallanExcel
                          : (this.state.gotDataApiType === 'Challan' || this.state.gotDataApiType === 'comboChallan' ) ?
                            api_sources.Challan
                          : []
                        }
                        options={{ placeholder: 'search source'}}
                        id="sourceUpdate"
                        className="form-control"
                        multiple={true}
                      />
                    </div>
                    <div className="submitRow">
                      <button className="backBtn" type="button" onClick={()=>{this.setState({updateSourcePopUp:false})}}>Cancel</button>
                      <button className="blueBtn" type="button" onClick={this.submitBulkSourceOrder}>Update</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            :
            ""
          }
        </React.Fragment>
      )
    } else {
      return (
        <UnAuthorised></UnAuthorised>
      )
    }
  }
}
